import { Container, Col, Row, Button, Spinner } from "react-bootstrap";
import { FaExternalLinkAlt } from "react-icons/fa";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getUrl, getStripeUrl } from "../../helpers/url";

import { useDispatch } from "react-redux";

import { setShowErrorModal } from "../../store/slice/modalSlice";

const ManagePlan = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [currentPlan, setCurrentPlan] = useState({});
  const [companyId, setCompanyId] = useState("");
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const fetchPlanDetails = async () => {
    try {
      setLoading(true);
      const companyId = searchParams.get("companyId");
      const userId = searchParams.get("userId");

      setCompanyId(companyId);
      setUserId(userId);

      let { data: subscriptionData } = await axios.post(
        getUrl("REACT_APP_FIND_CUSTOMER"),
        {
          companyId,
        }
      );
      if (!subscriptionData.plan)
        throw new Error(
          "Error while getting plan. Please try again after sometime"
        );

      setCurrentPlan(subscriptionData);
      setLoading(false);
    } catch (error) {
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      dispatch(setShowErrorModal({ message: message }));
    }
  };

  const openStripePortal = async () => {
    const companyId = searchParams.get("companyId");
    const userId = searchParams.get("userId");
    try {
      setBtnLoading(true);
      const { data: response } = await axios.post(
        getStripeUrl("REACT_APP_STRIPE_BILLING_PORTAL"),
        {
          customerKey: currentPlan.customerKey,
          returnUrl: `${window.location.origin}/setup?companyId=${companyId}&userId=${userId}&paymentStatus=none`,
        }
      );
      if (response.url) {
        window.open(response.url, "-blank");
      }
    } catch (error) {
      let message;
      if (error.response && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
      dispatch(setShowErrorModal({ message: message }));
    } finally {
      setBtnLoading(false);
    }
  };

  const planName = () => {
    if (currentPlan.plan.includes("cancelled")) {
      const planName = currentPlan.plan.replace("-cancelled", "");
      return (
        <span>
          <span className="current-plan-heading">
            {planName[0].toUpperCase() + planName.substring(1)}
          </span>{" "}
          - Plan cancelled upgrade your plan.
        </span>
      );
    } else {
      return currentPlan.plan[0].toUpperCase() + currentPlan.plan.substring(1);
    }
  };

  useEffect(() => {
    fetchPlanDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center loading-container">
          <div className="d-flex flex-row justify-content-center align-items-center">
            <Spinner animation="border" variant="success" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <Container className="my-5">
          <Row>
            <Col>
              <div className="px-4 d-flex flex-row justify-content-between align-items-center current-plan-container py-5">
                {currentPlan && Object.keys(currentPlan).length > 0 && (
                  <div className="pt-2">
                    <h4 className="current-plan-heading">
                      Usage count:{" "}
                      <span className="current-plan-name">
                        {currentPlan.usageCount}
                      </span>
                    </h4>
                    <h4 className="current-plan-heading">
                      Current plan:{" "}
                      <span className="current-plan-name">{planName()}</span>
                    </h4>
                  </div>
                )}
                <div>
                  <Button className="add-mapping-button me-3">
                    <a
                      href={`${window.location.origin}/subscription?companyId=${companyId}&userId=${userId}&paymentStatus=none`}
                      target="_blank"
                      className="manage-plan-btn"
                      rel="noreferrer"
                    >
                      Manage plan
                    </a>
                  </Button>
                  {currentPlan.customerKey && (
                    <Button
                      className="add-mapping-button"
                      onClick={() => openStripePortal()}
                    >
                      {btnLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span>
                          View billing details{" "}
                          <FaExternalLinkAlt
                            style={{ marginTop: "-3px" }}
                            className="ms-1"
                          />
                        </span>
                      )}
                    </Button>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default ManagePlan;
